import { render, staticRenderFns } from "./FractionsPieChart.vue?vue&type=template&id=7a30d783&"
import script from "./FractionsPieChart.vue?vue&type=script&lang=js&"
export * from "./FractionsPieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports